import { ArrowRight } from "lucide-react";
import { BrutalistBadge, GlassCard } from "@/app/components/brand-scaffold";
import { Button } from "@/app/components/ui/button";

const glassCardProps = {
  bgClass: "bg-white/75",
  hoverClass: "hover:bg-white/95",
  className: "!p-5 flex flex-col",
} as const;

export function HomepageMarketplacePreview() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-[#FACC15]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
            MARKETPLACE
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-4">
          Marketplace Preview
        </h2>
        <p className="text-lg font-bold text-zinc-600 mb-8 max-w-3xl">
          当前目录展示示例 Hotline 的 contract 结构。公开发布尚未开放，以下内容用于说明 Marketplace 的发现形态。
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mb-8">
          {previewPoints.map((point) => (
            <GlassCard key={point.title} {...glassCardProps}>
              <h3 className="font-black text-black mb-1">{point.title}</h3>
              <p className="text-sm text-zinc-700">{point.desc}</p>
            </GlassCard>
          ))}
        </div>
        <Button asChild variant="default" size="lg" className="gap-2">
          <a href="/marketplace">
            浏览示例 Hotline <ArrowRight className="h-5 w-5" strokeWidth={3} />
          </a>
        </Button>
      </div>
    </section>
  );
}

const previewPoints = [
  { title: "Hotline 如何被发现", desc: "通过 catalog 搜索和分类浏览。" },
  { title: "Contract 如何展示", desc: "summary、schema、examples、risk。" },
  { title: "Responder 信息", desc: "提供方和版本信息如何组织。" },
  { title: "Caller 决策", desc: "如何判断是否值得接入。" },
  { title: "状态标签", desc: "Preview / Demo / Coming Soon。" },
  { title: "开放时间线", desc: "公开发布、评分、结算尚未开放。" },
];
